import { snakeCase } from "lodash";

import {
  SET_ORDER_FORM_VALUE,
  SET_PROFILE_FORM_VALUE,
  SET_PEKERJAAN,
  SET_JENIS_KENDARAAN,
  SET_JENIS_PEMBIAYAAN,
  SET_JENIS_PRODUK,
  SET_TRANSAKSI,
  SET_UPDATED_TRANSAKSI,
  SET_JENIS_KEGIATAN_USAHA,
  SET_TRANSAKSI_PAYLOAD,
  SET_LIST_CRO,
  SET_JENIS_JAMINAN,
  SET_DAFTAR_CABANG,
  SET_DAFTAR_AREA,
  SET_CABANG_AREA,
  SET_BRAND_TYPE_MODEL,
  SET_VEHICLE_BRAND,
  SET_VEHICLE_YEAR,
  SET_KELURAHAN,
  SET_SUBMIT_STATUS,
  SET_LAST_RESPONSE,
  SET_FIRST_SIMULATION_STATUS,
  SET_FIRST_SIMULATION_RESULT,
  SET_SECOND_SIMULATION_STATUS,
  SET_SECOND_SIMULATION_RESULT,
  SET_DATA_AXI,
} from "@/stores/constants";
import {
  submitOrderFromReplikaRequest,
  submitOrderFromGrabRequest,
  submitOrderFromPromoRequest,
  submitOrderRequest,
  submitOrderMS2,
  createProfile,
  checkVehicleNumber,
  checkAxiId,
  checkVoucher,
  getPekerjaan,
  getJenisKendaraan,
  getJenisPembiayaan,
  getJenisProduct,
  getTransaksi,
  getUpdatedTransaksi,
  getTransaksiPayload,
  getJenisKegiatanUsaha,
  getListCro,
  updateTransaksi,
  updateTelecenter,
  checkAgentCode,
  checkTodayOrder,
  getJenisJaminan,
  getDaftarCabang,
  getParamArea,
  getBranchArea,
  getParamBrandTypeModel,
  getParamBrandByObjectGroupId,
  getParamMrp,
  getAlamatKelurahan,
  submitOrder,
  detailAxi,
  processIcrKtp,
} from "@/services/order";
import { simulation } from "../../services/order";
// import state from "sweetalert/typings/modules/state";

export default {
  namespaced: true,
  state: {
    order: {},
    profile: {},
    transaksi: {},
    payloadTransaksi: {},
    updatedTransaksi: {},
    listCro: {},
    jenisJaminan: [],
    daftarCabang: [],
    daftarArea: [],
    cabangArea: [],
    brandTypeModel: [],
    listVehicleBrand: [],
    listVehicleYear: [],
    listKelurahan: [],
    isSubmitting: false,
    lastResponse: null,
    firstSimulation: false,
    firstSimulationResult: null,
    secondSimulation: false,
    secondSimulationResult: null,
    dataAxi: [],
  },
  getters: {
    getOrderForm: (state) => state.order,
    getProfileForm: (state) => state.profile,
    getPekerjaan: (state) => state.order,
    getJenisKendaraan: (state) => state.order,
    getJenisPembiayaan: (state) => state.order,
    getJenisProduct: (state) => state.order,
    getTransaksi: (state) => state.transaksi,
    getUpdatedTransaksi: (state) => state.updatedTransaksi,
    getListCro: (state) => state.listCro,
    getTransaksiPayload: (state) => state.payloadTransaksi,
    getJenisKegiatanUsaha: (state) => state.order,
    getTipeJaminan: (state) => state.jenisJaminan,
    getListCabang: (state) => state.daftarCabang,
    getDaftarArea: (state) => state.daftarArea,
    getCabangArea: (state) => state.cabangArea,
    getBrandTypeModel: (state) => state.brandTypeModel,
    getVehicleBrand: (state) => state.listVehicleBrand,
    getVehicleYear: (state) => state.listVehicleYear,
    getListKelurahan: (state) => state.listKelurahan,
    getDataAxi: (state) => state.dataAxi,
  },
  mutations: {
    [SET_ORDER_FORM_VALUE](state, payload) {
      state.order = payload;
    },
    [SET_PROFILE_FORM_VALUE](state, payload) {
      state.profile = payload;
    },
    [SET_PEKERJAAN](state, payload) {
      state.order = payload;
    },
    [SET_JENIS_KENDARAAN](state, payload) {
      state.order = payload;
    },
    [SET_JENIS_PEMBIAYAAN](state, payload) {
      state.order = payload;
    },
    [SET_JENIS_PRODUK](state, payload) {
      state.order = payload;
    },
    [SET_JENIS_KEGIATAN_USAHA](state, payload) {
      state.order = payload;
    },
    [SET_TRANSAKSI](state, transaksi) {
      state.transaksi = transaksi;
    },
    [SET_UPDATED_TRANSAKSI](state, updatedTransaksi) {
      state.updatedTransaksi = updatedTransaksi;
    },
    [SET_TRANSAKSI_PAYLOAD](state, payloadTransaksi) {
      state.payloadTransaksi = payloadTransaksi;
    },
    [SET_LIST_CRO](state, listCro) {
      state.listCro = listCro;
    },
    [SET_JENIS_JAMINAN](state, jenisJaminan) {
      state.jenisJaminan = jenisJaminan;
    },
    [SET_DAFTAR_CABANG](state, daftarCabang) {
      state.daftarCabang = daftarCabang;
    },
    [SET_DAFTAR_AREA](state, daftarArea) {
      state.daftarArea = daftarArea;
    },
    [SET_CABANG_AREA](state, cabangArea) {
      state.cabangArea = cabangArea;
    },
    [SET_BRAND_TYPE_MODEL](state, brandTypeModel) {
      state.brandTypeModel = brandTypeModel;
    },
    [SET_VEHICLE_BRAND](state, listVehicleBrand) {
      state.listVehicleBrand = listVehicleBrand;
    },
    [SET_VEHICLE_YEAR](state, listVehicleYear) {
      state.listVehicleYear = listVehicleYear;
    },
    [SET_KELURAHAN](state, listKelurahan) {
      state.listKelurahan = listKelurahan;
    },
    [SET_SUBMIT_STATUS](state, status) {
      state.isSubmitting = status;
    },
    [SET_LAST_RESPONSE](state, response) {
      state.lastResponse = response;
    },
    [SET_FIRST_SIMULATION_STATUS](state, status) {
      state.firstSimulation = status;
    },
    [SET_FIRST_SIMULATION_RESULT](state, result) {
      state.firstSimulationResult = result;
    },
    [SET_SECOND_SIMULATION_STATUS](state, status) {
      state.secondSimulation = status;
    },
    [SET_SECOND_SIMULATION_RESULT](state, result) {
      state.secondSimulationResult = result;
    },
    [SET_DATA_AXI](state, dataAxi) {
      state.dataAxi = dataAxi;
    },
  },
  actions: {
    submitOrder({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);

      const formData = new FormData();

      Object.keys(payload).forEach((key) => {
        formData.append(snakeCase(key), payload[key]);
      });
      // console.log("submitOrder")
      return submitOrderRequest(formData);
    },
    submitOrderFromGrab({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);

      const formData = new FormData();

      Object.keys(payload).forEach((key) => {
        formData.append(snakeCase(key), payload[key]);
      });
      // console.log("submitOrder")
      return submitOrderFromGrabRequest(formData);
    },
    submitOrderFromPromo({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);

      const formData = new FormData();

      Object.keys(payload).forEach((key) => {
        if (key != "token") {
          let val = payload[key];
          if (key === "properties") {
            for (let property in val) {
              if (val.hasOwnProperty(property)) {
                formData.append(`${key}[${property}]`, val[property]);
              }
            }
          } else {
            formData.append(snakeCase(key), val);
          }
        }
      });
      // console.log(formData)
      return submitOrderFromPromoRequest(formData, payload.token);
    },
    submitOrderFromReplika({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);

      const formData = new FormData();

      Object.keys(payload).forEach((key) => {
        formData.append(snakeCase(key), payload[key]);
      });
      // console.log("submitOrder")
      return submitOrderFromReplikaRequest(formData);
    },
    submitOrderInMS2({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);
      // console.log("submitOrderInMS2")
      return submitOrderMS2(payload);
    },
    updateOrder({ commit }, payload) {
      commit(SET_ORDER_FORM_VALUE, payload);

      const formData = new FormData();
      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });
      // for (var pair of formData.entries()) {
      //   console.log(pair[0]+ ', ' + pair[1]);
      // }
      return updateTransaksi(formData, payload.orderId);
    },
    updateTelecenter({ commit }, payload) {
      return updateTelecenter(payload, payload.orderId);
    },
    /*
     * comment code for MPL (rise team)
     */
    submitProfile({ commit }, payload) {
      commit(SET_PROFILE_FORM_VALUE, payload);

      const newPayload = {};
      Object.keys(payload).forEach((key) => {
        newPayload[snakeCase(key)] = payload[key];
      });

      return createProfile(newPayload);
    },
    checkVehicleNumber({ commit }, id) {
      return checkVehicleNumber(id);
    },
    checkAxiId({ commit }, id) {
      return checkAxiId(id);
    },
    async checkAxiIdReplika({ commit }, id) {
      const result = await checkAxiId(id);
      const { data } = result.data;
      return data;
    },
    async fetchJenisJaminan({ commit }) {
      const result = await getJenisJaminan();
      const { data } = result;
      commit(SET_JENIS_JAMINAN, data);
      return data;
    },

    // comment for duplicate checkAxiIdReplika
    /*
    async checkAxiIdReplika({ commit }, id) {
      const result = await checkAxiId(id);
      // console.log(result);
      const { data } = result.data;
      return result.data.data;
      // return checkAxiId(id)
    },
    */
    checkVoucher({ commit }, id) {
      return checkVoucher(id);
    },
    async fetchPekerjaan({ commit }, params = {}) {
      const result = await getPekerjaan(params);
      const { data } = result;
      commit(SET_PEKERJAAN, data);
    },
    async fetchJenisKendaraan({ commit }, id) {
      const result = await getJenisKendaraan(id);
      const { data } = result;
      commit(SET_JENIS_KENDARAAN, data);
    },
    async fetchJenisPembiayaan({ commit }, params = {}) {
      const result = await getJenisPembiayaan(params);
      const { data } = result;
      commit(SET_JENIS_PEMBIAYAAN, data);
    },
    async fetchJenisProduct({ commit }, params = {}) {
      const result = await getJenisProduct(params);
      const { data } = result;
      commit(SET_JENIS_PRODUK, data);
    },
    async fetchJenisKegiatanUsaha({ commit }, params = {}) {
      const result = await getJenisKegiatanUsaha(params);
      const { data } = result;
      commit(SET_JENIS_KEGIATAN_USAHA, data);
    },
    async fetchTransaksi({ commit }, id) {
      const result = await getTransaksi(id);
      const { data } = result;
      commit(SET_TRANSAKSI, data);
    },
    async fetchUpdatedTransaksi({ commit }, id) {
      const result = await getUpdatedTransaksi(id);
      const { data } = result;
      commit(SET_UPDATED_TRANSAKSI, data);
    },
    async fetchListCro({ commit }, id) {
      const result = await getListCro(id);
      const { data } = result;
      commit(SET_LIST_CRO, data);
    },
    async fetchTransaksiPayload({ commit }, id) {
      const result = await getTransaksiPayload(id);
      const { data } = result;
      commit(SET_TRANSAKSI_PAYLOAD, data);
    },

    async fetchDaftarCabang({ commit }, payload) {
      const result = await getDaftarCabang(payload);
      const { data } = result;
      commit(SET_DAFTAR_CABANG, data);
      return data;
    },

    async fetchDaftarArea({ commit }) {
      const result = await getParamArea();
      const { data } = result;
      commit(SET_DAFTAR_AREA, data);
      return data;
    },

    async fetchBranchArea({ commit }, payload) {
      const result = await getBranchArea(payload);
      const { data } = result;
      commit(SET_CABANG_AREA, data);
      return data;
    },

    async fetchBrandTypeModel({ commit }, payload) {
      const result = await getParamBrandTypeModel(payload);
      const { data } = result;
      commit(SET_BRAND_TYPE_MODEL, data);
      return data;
    },

    async fetchBrandByObjectGroupId({ commit }, payload) {
      const result = await getParamBrandByObjectGroupId(payload);
      const { data } = result;
      commit(SET_VEHICLE_BRAND, data);
      return data;
    },

    async fetchVehicleYear({ commit }, payload) {
      const result = await getParamMrp(payload);
      const { data } = result;
      commit(SET_VEHICLE_YEAR, data);
      return data;
    },

    async fetchListKelurahan({ commit }, payload) {
      const result = await getAlamatKelurahan(payload);
      const { data } = result;
      commit(SET_KELURAHAN, data);
      return data;
    },

    async submitNewOrder({ commit }, { payload, token }) {
      commit(SET_SUBMIT_STATUS, true);
      try {
        const response = await submitOrder(payload, token);
        commit(SET_LAST_RESPONSE, response.data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        commit(SET_SUBMIT_STATUS, false);
      }
    },

    async processIcrKtp(_, payload) {
      try {
        const response = await processIcrKtp(payload);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    async firstSimulating({ commit }, payload) {
      commit(SET_FIRST_SIMULATION_STATUS, true);
      try {
        const response = await simulation(payload);
        commit(SET_FIRST_SIMULATION_RESULT, response.data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        commit(SET_FIRST_SIMULATION_STATUS, false);
      }
    },

    async secondSimulating({ commit }, payload) {
      commit(SET_SECOND_SIMULATION_STATUS, true);
      try {
        const response = await simulation(payload);
        commit(SET_SECOND_SIMULATION_RESULT, response.data);
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        commit(SET_SECOND_SIMULATION_STATUS, false);
      }
    },

    async fetchDataAxi({ commit }, payload) {
      const result = await detailAxi(payload);
      const { data } = result;
      commit(SET_DATA_AXI, data);
      return data;
    },

    checkAgentCode({ commit }, payload) {
      return checkAgentCode(payload);
    },
    checkTodayOrderNow({ commit }, payload) {
      return checkTodayOrder(payload);
    },
  },
};
